import { render, staticRenderFns } from "./toilets.vue?vue&type=template&id=6124b523&lang=html&"
import script from "./toilets.vue?vue&type=script&lang=js&"
export * from "./toilets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports